import { IStairConfig, IStepGeometry } from '@stair-craft/common/util';

export function generateLandingStep(
    flight1Count: number,
    riserHeight: number,
    turnStartZ: number,
    config: IStairConfig,
    index: number
): IStepGeometry {
    const sw: number = config.stairWidth;
    const isRight: boolean = config.turnDirection === 'right';
    const landingWidth: number = 2 * sw + config.flightGap;

    return {
        index,
        riserHeight,
        position: {
            x: isRight ? 0 : -(sw + config.flightGap),
            y: (flight1Count + 1) * riserHeight,
            z: turnStartZ,
        },
        treadWidth: landingWidth,
        treadDepth: sw,
        treadThickness: config.treadThickness,
        noseLength: 0,
        rotation: 0,
        isWinder: false,
        isLanding: true,
        // The landing's leading edge is closed only over flight 1; past it the edge hangs over
        // the gap and flight 2, whose own first riser stands at the same line.
        riserSpan: isRight ? { start: 0, end: sw } : { start: sw + config.flightGap, end: landingWidth },
    };
}
